import React from 'react';

import NoData from 'component/NoData';

class BasePageView extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { __initiated: false, error: false };
    this.setInitiated       = this.setInitiated.bind(this);
    this.closeModal         = this.closeModal.bind(this);
    this.escKeypressHandler = this.escKeypressHandler.bind(this);
    window.addEventListener('keydown', this.escKeypressHandler);
  }

  escKeypressHandler(e)
  {
    if (e.key === 'Escape' && this.state.modal) this.closeModal();
  }

  componentWillUnmount()
  {
    window.removeEventListener('keydown', this.escKeypressHandler);
  }

  hasError() { return !!this.state.error; }
  isNoData() { throw 'must implement abstract function <isNoData>.' }
  title() { throw 'must implement abstract function <title>.' }

  setInitiated(state) {
    this.setState(Object.assign(state, {__initiated: true}));
  }

  closeModal() { /* virtual */ }

  setError(error) { this.setState({ error }); }
  getErrorElement() {
    let msg = this.state.error;
    if (msg === true) {
      msg = <>
        <div>連接資料庫時發生錯誤，請聯絡你的系統管理員。</div>
        <div>Error occurred while retrieving data. Please contact your administrator.</div>
      </>;
    }
    return <div>{ msg }</div>
  }

  renderHeader = () => <h1 key="__PAGE_TITLE">{ this.title() }</h1>

  render()
  {
    let elm = [this.renderHeader()];
    elm.push(<div key="__PAGE_MAIN">
    {(() => {
      if ( !this.state.__initiated )
        return <>
          <div>正在連接資料庫。如此訊息維持過久，請聯絡你的系統管理員。</div>
          <div>Connecting to database. If this message keeps unchanged for a while, please contact your administrator.</div>
        </>
      else if ( this.hasError() )
        return this.getErrorElement();
      else if ( this.isNoData() )
        return <NoData />;
      else
        return this._render();
    })() }</div>);
    return <>{ elm }</>
  }



}

export default BasePageView;